import React, { Component } from "react";
import moment from "moment";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ValidatorForm } from "react-material-ui-form-validator";
import { withRouter } from "../../../withRouter";
import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import {
  FaCcVisa,
  FaCcMastercard,
  FaCcAmex,
  FaCcDiscover,
} from "react-icons/fa";
import { MdCreditCard } from "react-icons/md";
import Utils from "../../../provider/Utils";
import PtsAlert from "../ptsAlert/PtsAlert";
import EventBilling from "../billing/EventBilling";
import { Elements, ElementsConsumer } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CreditCardForm from "../billing/CreditCardForm";

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
);
class PurchaseEventPlan extends Component {
  header = store.getState().header.header;
  businessDomainId = store.getState().businessDomain?.businessDomainId;

  breadCrumb = [
    { pageid: "/eventMgmt", uiname: "Event List" },
    { pageid: "", uiname: "Purchase Event" },
  ];
  constructor(props) {
    super(props);
    let eventPlanId = props.eventPlanId;
    let eventId = props.eventId;
    let subscriptionId = props.subscriptionId;
    let pageId = props.pageId;
    // if (props.state) {
    //   eventPlanId = props.state.eventPlanId;
    //   eventId = props.state.eventId;
    //   subscriptionId = props.state.subscriptionId;
    // }

    if (null !== eventPlanId && eventPlanId > 0) {
      this.getPlanDetails(eventPlanId);
    }
    this.state = {
      eventPlanId: eventPlanId,
      subscriptionId: subscriptionId,
      eventId: eventId,
      pageId: pageId,
      eventplan: null,
      cardType: "",
      cardName: "",
      firstName: "",
      lastName: "",
      cardId: "",
      cardNumber: "",
      cardMonth: "",
      cardYear: "",
      cvvCode: "",
      isExpiryDate: false,
      render: false,
    };
  }

  getPlanDetails(eventPlanId) {
    const postObject = {
      header: this.header,
      plan: {
        id: eventPlanId,
      },
    };
    FetchServerData.callPostService("/planms/get", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let planDetails = output.data.plan;
          this.setState({
            eventplan: planDetails,
            render: true,
          });
        } else {
        }
      })
      .catch((error) => {});
  }

  handleCardTypeChange(e) {
    const { value } = e.target;
    this.setState({ cardType: value });
  }
  handleCardNumberChange(e) {
    let number = Utils.formatCardNumber(e.target.value);
    this.setState({ cardNumber: number });
  }
  handleCardNameChange(e) {
    this.setState({ cardName: e.target.value });
  }
  handleFirstNameChange(e) {
    this.setState({ firstName: e.target.value });
  }
  handleLastNameChange(e) {
    this.setState({ lastName: e.target.value });
  }

  handleCardMonthChange(date) {
    let newDate = moment(date).format("MM");
    this.setState({ cardMonth: newDate });
  }
  handleCardYearChange(date) {
    let newDate = moment(date).format("yyyy");
    this.setState({ cardYear: newDate });
  }
  handleCvvCodeChange(e) {
    this.setState({ cvvCode: e.target.value });
  }

  handleAddressLine1Change(e) {
    this.setState({ addressLine1: e.target.value });
  }
  handleAddressLine2Change(e) {
    this.setState({ addressLine2: e.target.value });
  }
  handleCityChange(e) {
    this.setState({ city: e.target.value });
  }

  handleStateChange(selectedState) {
    this.setState({ state: selectedState });
  }
  handlePinCodeChange(e) {
    this.setState({ zipCode: e.target.value });
  }

  handleExpiryDateChange(e) {
    let date = e.target.value?.replace(/[^0-9]/g, ""); // Remove non-numeric characters
    let month = "";
    let year = "";
    if (date.length > 6) date = date?.slice(0, 6); // Limit to 6 digits

    // Format as MM/YYYY
    if (date.length >= 3) {
      date = `${date.slice(0, 2)}/${date.slice(2)}`;
      month = date.slice(0, 2);
      year = date.slice(3);
    }
    // const valid = Utils.isExpiryValid(date);
    this.setState({
      expiryDate: date,
      cardMonth: month,
      cardYear: year,
      // isExpiryDate: !valid,
    });
  }

  getIcon = () => {
    switch (this.state.cardType) {
      case "visa":
        return <FaCcVisa size={32} color="#1a1f71" />;
      case "master card":
        return <FaCcMastercard size={32} color="#eb001b" />;
      case "american express":
        return <FaCcAmex size={32} color="#2e77bb" />;
      case "discover":
        return <FaCcDiscover size={32} color="#f76f02" />;
      default:
        return <MdCreditCard size={32} color="#aaa" />;
    }
  };

  purchasePlanToBackend() {
    if (this.state.pageId === "UpgradePlan") {
      this.updatePurchasePlanToBackend();
    } else {
      this.purchaseEventPlanToBackend();
    }
  }

  purchaseEventPlanToBackend() {
    const valid = Utils.isExpiryValid(this.state.expiryDate);
    if (!valid) {
      this.setState({
        isExpiryDate: true,
      });
      return;
    }

    const postObject = {
      header: this.header,
      plan: {
        id: this.state.eventPlanId,
      },
      event: {
        id: this.state.eventId,
      },
      creditCard: {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        type: this.state.cardType,
        number: this.state.cardNumber?.replace(/\s+/g, ""),
        month: this.state.cardMonth,
        year: this.state.cardYear,
        cvv: this.state.cvvCode,
      },
    };
    FetchServerData.callPostService(
      "/customerOrderms/purchasePlan",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.props.navigate("/eventMgmt");
        // this.props.navigate("/eventBilling", {
        //   state: {
        //     pageId: "EventBilling",
        //   },
        // });
      } else {
      }
    });
  }

  updatePurchasePlanToBackend() {
    const valid = Utils.isExpiryValid(this.state.expiryDate);
    if (!valid) {
      this.setState({
        isExpiryDate: true,
      });
      return;
    }
    const postObject = {
      header: this.header,
      plan: {
        id: this.state.eventPlanId,
      },
      subscriptionId: this.state.subscriptionId,
      creditCard: {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        type: this.state.cardType,
        number: this.state.cardNumber?.replace(/\s+/g, ""),
        month: this.state.cardMonth,
        year: this.state.cardYear,
        cvv: this.state.cvvCode,
      },
    };
    FetchServerData.callPostService(
      "/customerOrderms/upgradePlan",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        if (this.state.pageId === "PurchasePlan") {
          this.props.navigate("/eventBilling", {
            state: {
              pageId: "EventBilling",
            },
          });
          this.setState({
            render: true,
          });
        } else {
          this.setState({
            action: "billing",
          });
        }
      } else {
      }
    });
  }

  viewCancel() {
    if (this.state.pageId === "PurchasePlan") {
      // this.props.navigate("/eventBilling", {
      //   state: {
      //     pageId: "EventBilling",
      //   },
      // });
      // this.setState({
      //   render: true,
      // });
      this.props.navigate("/eventMgmt");
    } else {
      this.setState({
        action: "billing",
      });
    }
  }

  onSuccessPayment() {
    if (this.state.pageId === "PurchasePlan") {
      this.props.navigate("/eventBilling", {
        state: {
          pageId: "EventBilling",
        },
      });
      this.setState({
        render: true,
      });
    } else {
      this.setState({
        action: "billing",
      });
    }
  }

  UpgradePlanToBackend(data) {
    const postObject = {
      header: this.header,
      subscription: { id: this.state.subscriptionId },
      card: { id: data.creditCard?.id },
      plan: { id: this.state.eventplan?.id },
      eventId: this.businessDomainId,
    };
    FetchServerData.callPostService(
      "/paymentms/upgradeSubscription",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        this.setState({
          action: "billing",
        });
      }
    });
  }

  render() {
    if (this.state.action === "billing") {
      return <EventBilling action="view" />;
    } else {
      if (this.state.render === false) {
        return <div />;
      }
      return (
        <>
          {this.state.pageId !== "PurchasePlan" ? (
            <MenuWithBreadScrum
              breadCrumb={this.breadCrumb}
              navigate={this.props.navigate}
              backCallback={this.viewCancel.bind(this)}
              domainObject="Event"
              name="Purchase Event"
            />
          ) : (
            <div className="row">
              <div className="col-12">
                <div style={{ float: "left" }}>
                  <Button
                    type="submit"
                    variant="contained"
                    size="small"
                    style={{
                      background: "#6A7B8E",
                      color: "#fff",
                      textTransform: "capitalize",
                    }}
                    startIcon={<ArrowBackIcon />}
                    onClick={(e) => this.viewCancel(e)}
                  >
                    Back
                  </Button>
                </div>
              </div>
            </div>
          )}
          <div className="row mt-2">
            <div
              md={12}
              style={{
                width: "100%",
                color: "#000",
                fontSize: "small",
              }}
            >
              <div className="col-md-12">
                <div className="card " id="giveBeeCard">
                  <div className="card-body">
                    <div class="container">
                      <div class="row  justify-content-around">
                        <div className="col-md-4 align-self-center">
                          <div className="row d-flex align-item-stretch justify-content-center">
                            <div className="col-md-9 mt-4">
                              <div
                                className="row d-flex"
                                style={{
                                  height: "100%",
                                }}
                              >
                                <div className="col-md-12">
                                  <div
                                    className="box"
                                    data-aos="zoom-in"
                                    data-aos-delay={100}
                                    style={{
                                      padding: "0em",
                                      position: "relative",
                                      height: "100%",
                                    }}
                                    id="regPlanBox"
                                  >
                                    <div
                                      class="regplan-inner plan_card plan_card_bottom"
                                      style={{
                                        height: "100%",
                                      }}
                                    >
                                      <div
                                        class="entry-title plan_card"
                                        style={{
                                          background:
                                            this.state.eventplan
                                              ?.colorSecondary,
                                        }}
                                      >
                                        <h3
                                          class="plan_card"
                                          style={{
                                            padding: "7px",
                                            color: "#fff",
                                            background:
                                              this.state.eventplan
                                                ?.colorPrimary,
                                          }}
                                        >
                                          {this.state.eventplan?.name}
                                        </h3>
                                        <div
                                          class="price"
                                          style={{
                                            background:
                                              this.state.eventplan
                                                ?.colorPrimary,
                                          }}
                                        >
                                          <span
                                            style={{
                                              left: "20px",
                                            }}
                                          >
                                            {`$${this.state.eventplan?.price}`}
                                          </span>
                                        </div>
                                      </div>
                                      <div class="entry-content mb-4">
                                        <ul>
                                          {this.state.eventplan?.planItems.map(
                                            (planItem, index) => (
                                              <li
                                                style={{
                                                  padding: "0.2em",
                                                  fontWeight:
                                                    planItem?.isFontBold &&
                                                    "600",
                                                  fontStyle:
                                                    planItem?.isFontItalic &&
                                                    "italic",
                                                  fontSize:
                                                    planItem?.isFontSmall &&
                                                    "12px",
                                                }}
                                              >
                                                {planItem.name}
                                              </li>
                                            )
                                          )}
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <Elements stripe={stripePromise}>
                            <ElementsConsumer>
                              {({ stripe, elements }) => (
                                <CreditCardForm
                                  stripe={stripe}
                                  elements={elements}
                                  eventplan={this.state.eventplan}
                                  onSuccessPayment={this.onSuccessPayment.bind(
                                    this
                                  )}
                                  onUpgradePlan={this.UpgradePlanToBackend.bind(
                                    this
                                  )}
                                  action="list"
                                  subscriptionId={this.state.subscriptionId}
                                  pageId={this.state.pageId}
                                />
                              )}
                            </ElementsConsumer>
                          </Elements>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
  }
}
export default withRouter(PurchaseEventPlan);
